import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Booking } from './booking';
import { UserBookingsStore } from './user-bookings.store';

@Injectable()
export class UserBookingResolver  {

    constructor(private store: UserBookingsStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Booking> {
        const id = route.paramMap.get('id');
        return this.store.getWithDependencies(id);
    }
}
